import React from 'react';
import { Link } from 'react-router-dom';
import { PageTitle, PageSubTitle } from 'Components/Titles';
import RoundedPanel from 'Components/RoundedPanel';
import { Loader } from 'Components/Loader';
import { ErrorBoundary } from 'Components/ErrorBoundary/ErrorBoundary';
import { classCombine } from 'Utils/Utils';
import './CenterFrameLayout.css';
import { StatusIndicator } from 'Components/StatusIndicator';

function CenterFrameLayout({
  children,
  title,
  subtitle,
  status,
  statusType,
  noPanel,
  modernLayout,
  customClass = '',
  customFrameClass = '',
  showLoader,
  privacyMaskTitle,
  panelStyle,
  goBack = '',
  backUrl = '/',
}) {
  return (
    <ErrorBoundary name="center frame">
      <div
        className={classCombine(
          'centerFrameLayout',
          modernLayout && 'modernLayout',
          !title && 'topMargin',
          customClass
        )}
      >
        {(title || showLoader) && (
          <PageTitle modernLayout={modernLayout} text={title} alignText="center" privacyMaskTitle={privacyMaskTitle} />
        )}
        {subtitle && <PageSubTitle text={subtitle} alignText="center" />}
        {status && !showLoader && <StatusIndicator status={status} type={statusType} />}
        {goBack && (
          <Link to={backUrl} className="backButton">
            <img
              className="backIcon"
              src="/account/static/images/arrow-back-white.svg"
              width="20"
              height="20"
              alt="back-arrow"
            />
            <span className="backText">{goBack}</span>
          </Link>
        )}
        <RoundedPanel noPanel={noPanel} style={panelStyle}>
          <div className={classCombine('frameContentContainer', customFrameClass, showLoader && 'loading')}>
            {showLoader ? <Loader /> : children}
          </div>
        </RoundedPanel>
      </div>
    </ErrorBoundary>
  );
}

export default CenterFrameLayout;
